import * as React from "react";
import type { SVGProps } from "react";
const SvgBellIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="bell_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 42.667a298.667 298.667 0 0 0-298.667 298.666c0 143.062-30.592 231.894-58.794 283.563a253.312 253.312 0 0 1-37.547 53.077 129.579 129.579 0 0 1-13.013 12.118l-.128.085A42.667 42.667 0 0 0 128 768h768a42.667 42.667 0 0 0 24.15-77.824l-.086-.085a129.792 129.792 0 0 1-13.056-12.075 253.397 253.397 0 0 1-37.547-53.12c-28.16-51.67-58.794-140.501-58.794-283.563A298.667 298.667 0 0 0 512 42.667zm292.267 640H219.733c3.2-5.334 6.486-10.966 9.728-16.896 35.84-65.664 69.206-168.832 69.206-324.438a213.333 213.333 0 1 1 426.666 0c0 155.606 33.408 258.774 69.206 324.438 3.242 5.973 6.528 11.562 9.77 16.896zM475.093 874.58a42.667 42.667 0 1 0-73.813 42.838 128 128 0 0 0 221.44 0 42.667 42.667 0 0 0-73.813-42.838 42.667 42.667 0 0 1-73.814 0z"
    />
  </svg>
);
export default SvgBellIcon;
